import {effect, inject, Injectable, Injector} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {KeepAwake} from '@capacitor-community/keep-awake';
import {AppConfigManagerService} from '../../shared/app-config-manager.service';

@Injectable({
  providedIn: 'root'
})
export class KeepAwakeManagerService {

  private readonly injector = inject(Injector);
  private readonly appConfigManager = inject(AppConfigManagerService);


  /**
   * Mantener la pantalla activa según el ajuste de la configuración
   *
   */
  public watch(): void {

    if (!Capacitor.isNativePlatform()) {
      return;
    }

    effect(() => void this.apply(this.appConfigManager.appConfig().keepAwake), {injector: this.injector});
  }


  /**
   * Activar o desactivar el bloqueo de la pantalla
   *
   */
  private async apply(keepAwake: boolean): Promise<void> {

    try {
      await (keepAwake ? KeepAwake.keepAwake() : KeepAwake.allowSleep());

    } catch (error) {
      console.warn('Error to set keep awake:', error);
    }
  }
}
